import { render, staticRenderFns } from "./BandwidthLineMigrationModal.vue?vue&type=template&id=622ddc96&scoped=true&"
import script from "./BandwidthLineMigrationModal.vue?vue&type=script&lang=js&"
export * from "./BandwidthLineMigrationModal.vue?vue&type=script&lang=js&"
import style0 from "./BandwidthLineMigrationModal.vue?vue&type=style&index=0&id=622ddc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ddc96",
  null
  
)

export default component.exports